// Unpublished Work © 2020-2024 Deere & Company.

export const defaultFontFamily = 'Noto Sans';
